const selector = '.reveal-image .reveal-image__container';

const calculateRadius = () => {
	const revelImageCtr = document.querySelectorAll(selector);
	revelImageCtr.forEach((ctr) => {
		const img = ctr.querySelector('img');
		const radius = Math.sqrt(Math.pow(img.width, 2) + Math.pow(img.height, 2));
		ctr.style.setProperty('--radius', `${radius}px`);
	});
};

window.addEventListener('load', calculateRadius);
window.addEventListener('resize', calculateRadius);
